export const formatOrderAmount = (
  amount: string | number | null | undefined
): string | null => {
  if (amount === undefined || amount === null || amount === '') return null;
  const value = typeof amount === 'number' ? amount : Number(amount);
  if (Number.isNaN(value)) return String(amount);
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};
